import {
  all, call, fork, put, takeLatest,
} from 'redux-saga/effects';

// action creators
import { doneIndicator, error } from '../../actions/httpActions';
// api
import { find } from '../../sources/api/client';
import pnmService from '../../sources/api/pnmService';

// constants
import { PNM_FETCH_ALL_FOR_ANONYMOUS, PNM_FETCH_ALL_FOR_ANONYMOUS_INIT } from '../../constants/pnmTypes';

// lib
import httpSaga from '../../lib/httpSaga';

// schemas
import { pnmListSchema } from '../../schemas/pnm';

export function* fetchAllPnmsForAnonymous(action) {
  if (action['@@redux-saga/SAGA_ACTION']) return;

  const {
    search, sort, skip, infiniteScroll, chapter, filter,
  } = action.payload || {};

  try {
    const options = {
      query: {
        $search: search,
        $sort:   sort,
        $limit:  25,
        $skip:   skip,
        ...filter,
        chapter,
      },
    };

    yield* httpSaga(PNM_FETCH_ALL_FOR_ANONYMOUS, call(find, pnmService, options), {
      schema: pnmListSchema,
      infiniteScroll,
    });
  } catch (err) {
    yield put(error(PNM_FETCH_ALL_FOR_ANONYMOUS, err));
  } finally {
    yield put(doneIndicator(PNM_FETCH_ALL_FOR_ANONYMOUS));
  }
}

export function* watchPnmFetchAllForAnonymous() {
  yield takeLatest(PNM_FETCH_ALL_FOR_ANONYMOUS_INIT, fetchAllPnmsForAnonymous);
}

export default function* root() {
  yield all([
    fork(watchPnmFetchAllForAnonymous),
  ]);
}
